import { Stack } from 'expo-router';

import { getScreenTitleHeader } from '../../../components/get-screen-title-header';

const rewardsHeader = getScreenTitleHeader({ closeBehavior: 'tabHistory' });

const modalOptions = {
  presentation: 'containedTransparentModal' as const,
  headerShown: false,
  contentStyle: { backgroundColor: 'transparent' },
  animation: 'none' as const,
};

export default function RewardsTabLayout() {
  return (
    <Stack screenOptions={{ header: rewardsHeader }}>
      <Stack.Screen name="index" options={{ title: 'Rewards' }} />
      <Stack.Screen name="details" options={{ title: 'Rewards' }} />
      <Stack.Screen name="history" options={modalOptions} />
      <Stack.Screen name="birthday" options={modalOptions} />
      <Stack.Screen name="list/[rewardId]" options={{ title: 'Rewards Details' }} />
      <Stack.Screen name="offers" options={{ title: 'Offers' }} />
    </Stack>
  );
}
